
/**
 * Mapbox API token
 *
 * @category Configuration
 * @type {string}
 */
export const MAPBOX_ACCESS_TOKEN = `${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`;
